<div class="reporter-app">
  @if (!hideChromeForIframeView) {
    <reporter-header [disableClientChange]="(canChangeClient | async) === false"
      [attr.inert]="chromeInert ? '' : null"
      (logout)="logout()"
      (loginAdmin)="loginAdmin()"
      [whiteLabelLogoUri]="whiteLabelLogoUri">
    </reporter-header>
  }
  @if (showGlobalError) {
    <reporter-notifications></reporter-notifications>
  }
  <reporter-body [class.hide-chrome]="hideChromeForIframeView">
    <router-outlet></router-outlet>
  </reporter-body>
  @if (!hideChromeForIframeView) {
    <reporter-footer [attr.inert]="chromeInert ? '' : null"></reporter-footer>
  }
</div>
@if (loading) {
  <reporter-loading-indicator></reporter-loading-indicator>
}
